import { writable } from 'svelte/store';

export const messages = writable([]);
export const version = writable('1.0.3');
